"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Timer = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var Timer = /*#__PURE__*/function () {
  function Timer() {
    (0, _classCallCheck2["default"])(this, Timer);
  }

  (0, _createClass2["default"])(Timer, null, [{
    key: "TIMER",
    value: function TIMER() {
      var timeStart = new Date().getTime();
      return {
        get milliSecondsElapsed() {
          return new Date().getTime() - timeStart;
        }

      };
    }
  }]);
  return Timer;
}();

exports.Timer = Timer;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9VdGlscy9UaW1lci50cyJdLCJuYW1lcyI6WyJUaW1lciIsInRpbWVTdGFydCIsIkRhdGUiLCJnZXRUaW1lIiwibWlsbGlTZWNvbmRzRWxhcHNlZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztJQUVhQSxLOzs7Ozs7O1dBQ1gsaUJBQThCO0FBQzVCLFVBQU1DLFNBQVMsR0FBRyxJQUFJQyxJQUFKLEdBQVdDLE9BQVgsRUFBbEI7QUFDQSxhQUFPO0FBQ0wsWUFBSUMsbUJBQUosR0FBMEI7QUFDeEIsaUJBQVEsSUFBSUYsSUFBSixHQUFXQyxPQUFYLEtBQXVCRixTQUEvQjtBQUNEOztBQUhJLE9BQVA7QUFLRCIsInNvdXJjZVJvb3QiOiJvY3NkazovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgSVRpbWVyIGZyb20gXCIuLi8uLi9zcmMvSW50ZXJmYWNlcy9JVGltZXJcIjtcblxuZXhwb3J0IGNsYXNzIFRpbWVyIHtcbiAgcHVibGljIHN0YXRpYyBUSU1FUigpOiBJVGltZXIge1xuICAgIGNvbnN0IHRpbWVTdGFydCA9IG5ldyBEYXRlKCkuZ2V0VGltZSgpO1xuICAgIHJldHVybiB7XG4gICAgICBnZXQgbWlsbGlTZWNvbmRzRWxhcHNlZCgpIHtcbiAgICAgICAgcmV0dXJuIChuZXcgRGF0ZSgpLmdldFRpbWUoKSAtIHRpbWVTdGFydCk7XG4gICAgICB9XG4gICAgfTtcbiAgfVxufVxuIl19